import { useContext } from "react";
import { useSelector } from "react-redux";
import useDidMount from "../../../hooks/use-didmount";
import useWindowResize from "../../../hooks/useWIndowResize";
import useResponsiveImages from "../../../hooks/useResponsiveImages";
import { browser } from "../../../libs/helpers/browser";
import { isEmpty } from "../../../libs/helpers/object";
import { introSectionContext } from "../components/IntroSection/IntroSectionProvider";
import introSmallImage from '../../../assets/images/landing/intro--small.webp'
import introImage from '../../../assets/images/landing/intro.webp'

const useIntroSectionBanner = () => {
    const { isMobile } = useWindowResize();
    const { activePromotion, activePromotionDone } = useSelector(state => ({
        activePromotionDone: state.HomeInsurance.activePromotionDone,
        activePromotion: state.HomeInsurance.activePromotion,
    }));
    const responsiveImage = useResponsiveImages({
        default: { webp: introSmallImage },
        600: { webp: introImage },
    });
    const hasPromotion = !isEmpty(activePromotion);
    const getImagePromotion = promotion => {
        return isMobile ? promotion.urlMobile : promotion.urlDesktop;
    };
    const introAsset = hasPromotion
        ? getImagePromotion(activePromotion)
        : responsiveImage.webp;
    const { setLoadedBanner } = useContext(introSectionContext);
    useDidMount(() => {
        if (!isMobile) setLoadedBanner(true);
    });

    return { activePromotionDone, hasPromotion, introAsset, setLoadedBanner };
};

export default useIntroSectionBanner;
